import { state } from './shared-variables';
(function($) {
  let filter_post_type = 'filter_post_type';
  let baseFontSize = 16;
  let filter_page = 1;
	$(document).ready(function() {
    $('.profab-models #post-tax-filters select, #post-attribute-filters input[type="checkbox"], #sort_by').on('change', profabHandleFiltersQueryParams);
    $('.profab-models input[name='+filter_post_type + ']').on('change', profabHandleFiltersQueryParams);
    $('.profab-models .profab-slider-input').on('input', debounce(profabHandleFiltersQueryParams, 250));

    $('body').on('click', '.profab-models #filters-pagination a, .profab-models .profab-filters-more a', profabHandleFiltersQueryParams);
    $('.profab-models #post-filters-form').on('submit', profabHandleFiltersQueryParams);
    $(document).on('click', '.profab-tag-checkbox', profabTagsCheckBox);
    $(document).on('click', '#filtered_scroll_top', profabScrollTopFilters);

    $('#filters-text-search').on('keyup', debounce(function(){
      $('#post-filters-form').submit();
    },400));
    $('#filters-text-search').on('search', function(){
      $('#post-filters-form').submit();
    });
  
    if(history.pushState){
      let search_params_load = new URLSearchParams(window.location.search);
      filter_page = search_params_load.get('filter_page');
      if(filter_page){
        let content_height = $('#filtered-content-container').outerHeight();
        
        let each_page_height = content_height/filter_page;
        //Set max-height to one page
       // $('#post-filters-form #filtered-content').css('max-height', pxToRem(each_page_height - ($('.profab-model-block').outerHeight() - 100)) + "rem");
        //Scroll to page
        //$('#post-filters-form #filtered-content').scrollTop((each_page_height * (filter_page-1)) + ($('.profab-model-block').outerHeight()*2) + 150);
      }
    }

  })

  function pxToRem(pxValue) {
    const remValue = pxValue / baseFontSize;

    return remValue;
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
      method();
    }, delay);
  }
  
  /**
   * Function called when a filter checkbox changes, a pagination change is requested or when the search input has been submitted.
   * Used to dynamically add the filter params to the URL. We add the filters to the URL to make sure that when a user clicks "back" in his browser, he will keep the filters he was on.
   * When all the filters are in the URL, it triggers the AJAX call to refresh the content based on the URL parameters.
   */
  function profabHandleFiltersQueryParams(e){
    // If the browser supports pushState
    if(history.pushState){
      let search_params = new URLSearchParams(window.location.search);
      let all_tax_names = [];
      
      //Creates an array of all the taxonomies that can be filtered by parsing the checkboxes
      $('#post-tax-filters select').each(function() {
        if(all_tax_names.indexOf($(this).data('taxonomy')) == -1){
          all_tax_names.push($(this).data('taxonomy'));
        }
      });

      $('#post-attribute-filters input[type="checkbox"]').each(function () {
        if (all_tax_names.indexOf($(this).data('taxonomy')) == -1) {
          all_tax_names.push($(this).data('taxonomy'));
        }
      });

      if (all_tax_names.indexOf($('#post-slider-budget').data('taxonomy')) == -1) {
        all_tax_names.push($('#post-slider-budget').data('taxonomy'));
      }

      //Append all selected term IDs for all the taxonomies to the URL
      $.each(all_tax_names, (index, taxonomy_name) => {
        let selected_terms = [];
        
        $('#post-tax-filters select[data-taxonomy="'+taxonomy_name+'"] option:checked').each(function() {
          if($(this).val()){
            selected_terms.push($(this).val());
          }
        });

        $('#post-attribute-filters input[data-taxonomy="' + taxonomy_name + '"]:checked').each(function () {
          selected_terms.push($(this).val());
        });

        $('#post-slider-budget[data-taxonomy="' + taxonomy_name + '"] input').each(function () {
          if($(this).index() + 1 == Math.round($('#post-slider-filters .profab-slider-input').val()) && $(e.target).parent().attr('id') == 'post-slider-filters'){
            selected_terms.push($(this).val());
          }
        });
        let filter_name = taxonomy_name + '_filters';
        if(selected_terms.length > 0){
          if(taxonomy_name == filter_post_type){
            filter_name = taxonomy_name;
          }
          search_params.set(filter_name, selected_terms.join());
        }
        else{
          if(taxonomy_name == filter_post_type){
            filter_name = taxonomy_name;
          }
          search_params.delete(taxonomy_name + '_filters');
        }
      });

      
      if($('input[name="filters-aliases"]').length){
        let aliases = [];
        $("input:checkbox[name='filters_inspirations[]']:checked").each(
          function () {
            aliases.push($(this).val());
          }
        );
        if(aliases.length){
          search_params.set("filters_inspirations", aliases);
        }else{
          search_params.delete("filters_inspirations");
        }
      }

      let post_types = [];
      $("input:checkbox[name='" + filter_post_type + "[]']:checked").each(
        function () {
          post_types.push($(this).val());
        }
      );
      // If Post type select change, append to the URL
      if (e.target.id == filter_post_type) {
        if ($(this).val()) {
          post_types.push($(this).val());
        }
      }
      // If Sort By select change, append to the URL
      let sort_by = null;

      $('#sort_by option:checked').each(function() {
        if($(this).val()){
          sort_by = $(this).val();
        }
      });

      if(sort_by){
        search_params.set('sort_by', sort_by);
      }
      else{
        search_params.delete('sort_by');
      }
      
     
      if(post_types.length){
        search_params.set(filter_post_type, post_types);
      }else{
        search_params.delete(filter_post_type);
      }

      //If the clicked object is a pagination link
      if($(this).hasClass('page-numbers')){
        e.preventDefault();
        let pagination_link = $(this).attr('href');
        let page_number_matches = pagination_link.match(/\/page\/(\d*)/);
        //If the regex found matches for a page number
        if(page_number_matches){
          search_params.set('filter_page', page_number_matches[1]);
        }
        else{
          //If there's no page number found, remove the page param
          search_params.delete('filter_page');
        }
      }
      else if($(this).data('taxonomy') || $(this).is('input[type=range]') || e.target.id == 'sort_by' || $(this).is('input:checkbox[name="filters_inspirations[]"]')){
        //If it's a filter checkbox has changed, reset the pagination so we go back to the first page
        search_params.delete('filter_page');
      }
      else if($(this).is('form')){
        //If the search input has been submitted, set the search URL param
        if($('#filters-text-search').val()){
          search_params.set('search', $('#filters-text-search').val());
        }
        else{
          search_params.delete('search');
        }
        //Reset the pagination so we go back to the first page
        search_params.delete('filter_page');
      }

      // The new url string
      let new_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
      if(search_params.toString()){
        new_url += '?' + search_params.toString();
      }
      window.history.pushState({path: new_url}, '', new_url);

      //Trigger the content refresh
      profabRefreshFilteredContent(search_params.toString());

      if(e.target.getAttribute("data-taxonomy") == "province") {
        let term_id = $(e.target).find(":selected").attr('id');

        if(term_id == undefined && e.target.value == ""){
          term_id = "";
        }
        else {
          term_id = term_id.replace('term-', '');
        }

        profabRefreshRegions(term_id);
      }
    }

    return false;
  }

  /**
   * Function making an AJAX request in order to refresh the content based on the filters.
   * @todo: Slow the query and add a loading screen.
   * @param {string} search_params: Query string containing all the filters
   */
  function profabRefreshFilteredContent(search_params){
    let $results_container = $('#filtered-content');
    
    if($results_container.length > 0){
      let urlParams = new URLSearchParams(search_params);
      let post_types = [];
      let all_post_types = [];
      if(urlParams.get('filter_post_type')){
        post_types = urlParams.get("filter_post_type").split(',');
        $('input[name="filters-all-post-type[]"]').each(function() {
          all_post_types.push($(this).val());
        });
      }
      else{
        $('input[name="filters-all-post-type[]"]').each(function() {
          post_types.push($(this).val());
          all_post_types.push($(this).val());
        });
      }
      let aliases = null;
      if($('input[name="filters-aliases"]').length){
        if(urlParams.get('filters_inspirations')){
          aliases = urlParams.get('filters_inspirations');
        }else{
          aliases = $('input[name="filters-aliases"]').val();
        }
      }
      let is_page = urlParams.get('filter_page');
      let content = is_page ? $('#filtered-content-container').html() : null;
      let contentHeight = is_page ? $('#filtered-content-container').outerHeight() : null;

      $.ajax({
        url: ajax.url + '?' + search_params,
        type: 'GET',
        data: {
          action: 'profab_filtered_content',
          post_type: post_types,
          all_post_types: all_post_types,
          compare_selected: state.modelsIds,
          aliases: aliases,
          leoregion: getCookie('leoregion'),
        },
        beforeSend: function () {
          $('.profab-loading-container').addClass('loading');
          $('.profab-filters-more a.page-numbers').hide();
        },
        success: function(result) {
          $('.profab-filters-more a.page-numbers').show();
          $('.profab-loading-container').removeClass('loading');
          $results_container.empty();
          $results_container.append(result);
          let new_position = $('#filters-anchor').offset().top;
          if(is_page){
            $('#filtered-content-container').prepend(content);

            let content_height = $('#filtered-content-container').outerHeight();
            let each_page_height = content_height/is_page;

            //Set max-height to one page
            //$('#filtered-content').css('max-height', pxToRem(each_page_height - ($('.profab-model-block').outerHeight() + 100)) + "rem");

            //$('#filtered-content').scrollTop(contentHeight);
          }
          else{
            //$('#filtered-content').css('max-height', pxToRem($('#filtered-content-container').outerHeight() + 250) + "rem");
          }

          //$('html, body').stop().animate({ scrollTop: new_position });
          
        }
      });
    }
  }

  function profabScrollTopFilters(){
    let anchor_position = $('#filters-anchor').offset().top;
    $('html, body').stop().animate({ scrollTop: anchor_position });
  }

  function profabTagsCheckBox(){
    $(this).prev().click();
  }

  function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  var debounce = function (func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
  };

  function profabRefreshRegions(term_id) {
    let $results_container = $('select[data-taxonomy="region"]');

    $.ajax({
      url: ajax.url,
      type: 'GET',
      data: {
        action: 'profab_filtered_regions',
        province: term_id,
      },
      beforeSend: function () {
        $('.profab-loading-container').addClass('loading');
      },
      success: function(result) {
        $('.profab-loading-container').removeClass('loading');

        $results_container.empty();
        $results_container.append(result);        
      }
    });
  }
})(jQuery);